import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faEnvelope,
  faEye,
  faQuestion,
  faUser,
  faUsers,
  faExclamationCircle,
} from "@fortawesome/free-solid-svg-icons";
import React, { Fragment, useState, useEffect } from "react";
import GetStudentService from "../../../services/SchoolIT/GetStudentService";
import moment from "moment";
import AppHeader from "../../../Layout/AppHeader";
import AppSidebar from "../../../Layout/AppSidebar";
import { useHistory } from "react-router-dom";
import "./MessageCenter.css";

const IMG_URL = process.env.REACT_APP_IMAGE_ASSET_URL;

const MessageCenter = () => {
  let history = useHistory();
  const [user] = useState(
    localStorage.getItem("user") && JSON.parse(localStorage.getItem("user"))
  );
  const [page] = useState(1);
  const [messageDetails, setMessageDetails] = useState();
  const [groupMessageDetails, setGroupMessageDetails] = useState([]);
  const [groupPage] = useState(1);

  const getStudentMessage = () => {
    let obj = {
      counselor_id: user?.counselor_id,
      event_type: "school_it_student",
      page: page,
    };
    GetStudentService.getMessageForStudentInIT(obj)
      .then((data) => {
        setMessageDetails(data?.data?.data);
      })
      .catch(() => {});
  };

  const getGroupMessageDetails = () => {
    let obj = {
      counselor_id: user?.counselor_id,
      page: groupPage,
      school_id: user?.school_id,
    };
    GetStudentService.getMessageForGroupInIT(obj)
      .then((data) => {
        setGroupMessageDetails(data.data);
      })
      .catch(() => {});
  };

  useEffect(() => {
    getStudentMessage();
    getGroupMessageDetails();
  }, []);

  const navigateToStudents = (item, index) => {
    history.push({
      pathname: "/school_it/message-students",
      state: item,
      open: true,
      index: index,
    });
  };

  const getGroupName = (item) => {
    try {
      return JSON.parse(item?.groups?.replace(/'/g, '"'))["1"]?.name;
    } catch (_) {
      return "Group";
    }
  };

  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="message-center-page">
            <div className="message-center-header">
              <div>
                <h1 className="message-center-heading">Messages</h1>
                <p className="message-center-subheading">
                  Review recent student and group conversations
                </p>
              </div>
              <div className="message-center-actions">
                <button
                  type="button"
                  onClick={() => {
                    history.push({
                      pathname: "/school_it/message-students",
                      openCreateMessage: true,
                    });
                  }}
                  className="message-center-btn"
                >
                  <FontAwesomeIcon icon={faUser} />
                  Create Student Message
                </button>
                <button
                  type="button"
                  onClick={() => {
                    history.push({
                      pathname: "/school_it/message-groups",
                      openCreateGroupMessage: true,
                    });
                  }}
                  className="message-center-btn secondary"
                >
                  <FontAwesomeIcon icon={faUsers} />
                  Create Group Message
                </button>
              </div>
            </div>

            <div className="message-center-container">
              <div className="message-single-grid">
                <span
                  className="message-center-title"
                  onClick={() => history.push("/school_it/students")}
                >
                  <FontAwesomeIcon icon={faUser} />
                  Students
                </span>
                <div className="message-center-list">
                  {messageDetails?.length > 0 ? (
                    messageDetails.map((item, index) => (
                      <div
                        key={item?.src_id || item?.id || index}
                        onClick={() => navigateToStudents(item, index)}
                        className="message-center-item"
                      >
                        <div className="message-center-item-row">
                          <div className="message-center-user">
                            <img
                              className="message-center-avatar"
                              src={IMG_URL + "CounselorPlaceholder.png"}
                              alt=""
                            />
                            <p className="message-center-name">
                              {item?.priority === "critical" && (
                                <span className="message-center-critical">
                                  <FontAwesomeIcon icon={faExclamationCircle} />
                                </span>
                              )}
                              {item?.name}
                            </p>
                          </div>
                          <p className="message-center-time">
                            {moment(item?.date || item?.time).format(
                              "ddd DD MMM YYYY, hh:mm A"
                            )}
                          </p>
                        </div>
                        <p className="message-center-preview">
                          {item?.last_message}
                        </p>
                      </div>
                    ))
                  ) : (
                    <div className="message-center-empty">
                      No student messages yet
                    </div>
                  )}
                </div>
              </div>

              <div className="message-single-grid">
                <span
                  className="message-center-title"
                  onClick={() => history.push("/school_it/message-groups")}
                >
                  <FontAwesomeIcon icon={faUsers} />
                  Groups
                </span>
                <div className="message-center-list">
                  {groupMessageDetails?.result &&
                  Object.values(groupMessageDetails?.result)?.length > 0 ? (
                    Object.values(groupMessageDetails?.result).map(
                      (item, index) => (
                        <div
                          key={item?.id || index}
                          className="message-center-group-item"
                          onClick={() =>
                            history.push("/school_it/message-groups")
                          }
                        >
                          {item?.priority === "critical" && (
                            <div className="message-center-group-critical">
                              <FontAwesomeIcon icon={faExclamationCircle} />
                            </div>
                          )}
                          <div>
                            <span className="message-center-group-chip">
                              {getGroupName(item)}
                            </span>
                            <p className="message-center-time" style={{ textAlign: "right" }}>
                              {moment(item?.date_sent).format(
                                "ddd DD MMM YYYY, h:mm A"
                              )}
                            </p>
                            <p className="message-center-group-subject">
                              {item?.subject}
                            </p>
                          </div>
                          <div className="message-center-group-meta">
                            <span>
                              <FontAwesomeIcon icon={faEnvelope} />
                              {item?.count_messages}
                            </span>
                            <span>
                              <FontAwesomeIcon icon={faEye} />
                              {item?.count_opened}
                            </span>
                            <span>
                              <FontAwesomeIcon icon={faCheck} />
                              {item?.count_ack}
                            </span>
                            <span>
                              <FontAwesomeIcon icon={faQuestion} />
                              {item?.count_feedback}
                            </span>
                          </div>
                        </div>
                      )
                    )
                  ) : (
                    <div className="message-center-empty">
                      No group messages yet
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default MessageCenter;
